import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import { useSelector } from 'react-redux';
import { isValidCSSColor } from 'utils/stringUtils';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '4px 0',
  },
  text: {
    color: theme.palette.ADACompliantRed,
  },
}));

const DisclaimerEntry = ({ value, linkDisclaimerStyle }) => {
  const classes = useStyles();

  const { clientDetails } = useSelector(state => state.main);
  // Extract client linkDisclaimerStyle from metadata if available
  const clientLinkDisclaimerStyle = _get(
    clientDetails,
    'metadata.linkDisclaimerStyle',
    {},
  );

  // Use linkDisclaimerStyle if provided, otherwise use clientLinkDisclaimerStyle
  const finalLinkDisclaimerStyle = !_isEmpty(linkDisclaimerStyle)
    ? linkDisclaimerStyle
    : clientLinkDisclaimerStyle;

  // Validate fontSize
  const linkFontSize = _get(finalLinkDisclaimerStyle, 'fontSize', 12);
  const validFontSize =
    typeof linkFontSize === 'number' && linkFontSize > 0 ? linkFontSize : 12;

  // Validate fontColor using shared utility
  const validFontColor = isValidCSSColor(
    _get(finalLinkDisclaimerStyle, 'fontColor'),
  )
    ? finalLinkDisclaimerStyle.fontColor
    : undefined;

  return (
    <Box className={classes.container}>
      <RichTextReactRenderer
        data={value}
        fontSize={{
          mobile: validFontSize,
          tablet: validFontSize,
          desktop: validFontSize,
        }}
        className={!validFontColor ? classes.text : undefined}
        color={validFontColor}
      />
    </Box>
  );
};

DisclaimerEntry.propTypes = {
  value: PropTypes.string,
  linkDisclaimerStyle: PropTypes.object,
};

export default DisclaimerEntry;
